import * as React from "react"
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"
import { type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"
import { toggleVariants } from "@/components/ui/toggle"

export interface DeptOption {
  label: string
  value: string
}

export type DeptToggleGroupProps = React.ComponentProps<
  typeof ToggleGroupPrimitive.Root
> & {
  className?: string
  options?: DeptOption[]
  children?: undefined
}

function DeptToggleGroup({ className, ...props }: DeptToggleGroupProps) {
  return (
    <ToggleGroupPrimitive.Root
      data-slot="toggle-group"
      className={cn(
        `
          group/toggle-group flex w-fit items-center rounded-sm
          bg-white text-blue border border-input-border text-base
          max-w-full overflow-auto
        `,
        className
      )}
      {...props}
    >
      {props.options?.map((option) => (
        <DeptToggleGroupItem key={option.value} value={option.value}>
          {option.label}
        </DeptToggleGroupItem>
      ))}
    </ToggleGroupPrimitive.Root>
  )
}

function DeptToggleGroupItem({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Item> &
  VariantProps<typeof toggleVariants>) {
  return (
    <ToggleGroupPrimitive.Item
      data-slot="toggle-group-item"
      className={cn(
        `
          min-w-0 shrink-0 rounded-none shadow-none first:rounded-l-sm last:rounded-r-sm 
          h-9 hover:cursor-pointer font-semibold px-6 border-r border-input-border
          last:border-r-transparent data-[state='on']:bg-blue
          data-[state='on']:text-white transition-colors
        `,
        className
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Item>
  )
}

export { DeptToggleGroup, DeptToggleGroupItem }
